var map = {
	"./durga-1.png": 615,
	"./durga-10.png": 217,
	"./durga-2.png": 9,
	"./durga-3.png": 596,
	"./durga-4.png": 405,
	"./durga-5.png": 63,
	"./durga-6.png": 46,
	"./durga-7.png": 599,
	"./durga-8.png": 681,
	"./durga-9.png": 20,
	"./durga-bg.png": 844
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 725;